import { useCallback } from 'react';

import {
  useApiDelete,
  useApiGet,
  useApiPost
} from '../../common/api/Api.hooks';
import api, { ApiParams } from '../../common/api/api';
import { apiResolve } from '../../common/api/apiResolve';
import { TaskJiraIssueV2 } from './TaskJiraIssueV2.interface';

export function findTaskJiraIssuesV2(taskId: number, params: ApiParams = {}) {
  const request = api.get(`tasks-jira-v2/${taskId}`, params);
  const result = apiResolve<TaskJiraIssueV2[]>(request);
  return { request, result };
}

export function useFindTaskJiraIssuesV2(taskId: number) {
  const { data, get, ...result } = useApiGet<TaskJiraIssueV2[]>(
    `tasks-jira-v2/${taskId}`
  );
  return { ...result, taskJiraIssues: data, findTaskJiraIssues: get };
}

export function useCreateTaskJiraIssueV2() {
  const { post, ...result } = useApiPost<TaskJiraIssueV2>('tasks-jira-v2');
  const createTaskJiraIssue = useCallback(
    (params: Partial<TaskJiraIssueV2>) => post(params),
    [post]
  );
  return { ...result, createTaskJiraIssue };
}

export function useDeleteTaskJiraIssueV2(id: number | undefined) {
  const { data, del, ...result } = useApiDelete(`tasks-jira-v2/${id}`);
  return { ...result, deletedJiraIssue: data, deleteTaskJiraIssue: del };
}
